var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"about_content",staticClass:"base_text",class:{
       'base_ellipsis':!_vm.more,
       'base_ellipsis_2':_vm.more&&_vm.number === 2
    }},[_c('div',{ref:"about_content_box"},[_vm._v(_vm._s(_vm.text))]),(_vm.showMore&&_vm.haveMore)?_c('span',{staticClass:"btn",on:{"click":function($event){_vm.more = !_vm.more}}},[(_vm.more)?_c('span',{staticClass:"dian"},[_vm._v("...")]):_vm._e(),_vm._v(" "+_vm._s(_vm.more?'展开':'收起')+" "),_c('van-icon',{attrs:{"name":_vm.more?'arrow-down':'arrow-up'}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }